import { Controller } from "@hotwired/stimulus"

const debug = false
/**
 * Thank you gemini.
 *
 * Put on an arbitrary node.
 *
 * Put a data-action="click->click-open#toggle" on the element that does the action.
 *
 * Make sure an element has data-click-open-target="content". That one toggles on and off.
 *
 * <div data-controller="click-open">
 *   <button data-action="click->click-open#toggle">Toggle</button>
 *   <div class="slide-content" data-click-open-target="content">Content
 * </div>
 *
 */
export default class extends Controller {
  static targets = ["content"]

  connect() {
    if (debug) console.info("ClickOpen::connect")
    // Generate a random string of six letters
    const randomString = Math.random().toString(36).substring(7)

    // Add the attribute to the element
    if (!this.element.hasAttribute("data-click-open-id")) {
      const randomId = this.generateRandomId()
      this.element.dataset.clickOpenId = randomId
      this.clickOpenId = randomString
    } else {
      this.clickOpenId = this.element.dataset.clickOpenId
    }

    // Add event listener to the document
    document.addEventListener("GTMP::ClickOpen::Expand", (event) => {
      if (this.clickOpenId !== event.detail) {
        this.collapse()
      }
    })
  }

  generateRandomId() {
    return `x_${Math.random().toString(36).substring(2, 8)}`
  }

  // Bind the toggle method to the controller instance
  // to prevent context issues if passed as a callback
  toggle(event) {
    if (event) event.preventDefault()

    if (this.isExpanded) {
      this.collapse(event.currentTarget)
    } else {
      this.expand(event.currentTarget)
    }
  }

  expand(clickedElement) {
    // 1. Get the natural height of the content
    const contentHeight = this.contentTarget.scrollHeight

    // 2. Set the height explicitly so CSS transition runs
    this.contentTarget.style.height = `${contentHeight}px`

    // 3. Mark as expanded
    this.contentTarget.dataset.expanded = "true"
    if (clickedElement) {
      clickedElement.setAttribute("data-state", "open")
      if (debug) console.info(`ClickedElement::${clickedElement.outerHTML}`)
    }

    // 4. Emit event
    let customEvent = new CustomEvent("GTMP::ClickOpen::Expand", { detail: this.clickOpenId })
    document.dispatchEvent(customEvent)
  }

  collapse(clickedElement) {
    // 1. Set height back to 0
    this.contentTarget.style.height = "0px"

    // 2. Mark as collapsed
    delete this.contentTarget.dataset.expanded
    if (clickedElement) {
      clickedElement.setAttribute("data-state", "closed")
      if (debug) console.info(`ClickedElement::${clickedElement.outerHTML}`)
    }
  }

  // Helper to check current state
  get isExpanded() {
    return this.contentTarget.dataset.expanded === "true"
  }
}